import { useEffect, useMemo, useState } from 'react';

import { getStyleVariableValue } from '../util/helpers';

const XS = getStyleVariableValue('--breakpoint-xs');
const MD = getStyleVariableValue('--breakpoint-md');
const LG = getStyleVariableValue('--breakpoint-lg');
const XL = getStyleVariableValue('--breakpoint-xl');
const XXl = getStyleVariableValue('--breakpoint-xxl');
const XXXl = getStyleVariableValue('--breakpoint-xxxl');

const useWindowSize = () => {
  const [width, setWidth] = useState(window.innerWidth);
  const [height, setHeight] = useState(window.innerHeight);

  const handleResize = () => {
    setWidth(window.innerWidth!);
    setHeight(window.innerHeight!);
  };

  useEffect(() => {
    handleResize();
    window.addEventListener('resize', handleResize);

    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const mobile = useMemo(() => (width ? width <= parseInt(XS, 10) : false), [width]);
  const medium = useMemo(() => (width ? width <= parseInt(MD, 10) : false), [width]);
  const smallTablet = useMemo(() => (width ? width <= parseInt(LG, 10) : false), [width]);
  const tablet = useMemo(() => (width ? width <= parseInt(XL, 10) : false), [width]);
  const desktop = useMemo(() => (width ? width > parseInt(XL, 10) && width <= parseInt(XXl, 10) : false), [width]);
  const HD = useMemo(() => (width ? width <= parseInt(XXl, 10) : false), [width]);
  const laptop = useMemo(() => (width ? width <= parseInt(XXXl, 10) : false), [width]);
  const fullHD = useMemo(() => (width ? width > parseInt(XXXl, 10) : false), [width]);

  return {
    width,
    height,
    mobile,
    medium,
    smallTablet,
    tablet,
    desktop,
    HD,
    laptop,
    fullHD,
  };
};

export default useWindowSize;
